import React, { Component, useState } from 'react';
import { inject, observer } from 'mobx-react';
import ProviderStore from '../../stores/ProvidersStore';
import TestSubscription from './TestSubscription';
import { Link, Redirect } from 'react-router-dom';
import { PROVIDERS_PAGE_PATH } from '../../Settings';
import ProviderDetails from './ProviderDetails';
import SwitcherComponent from '../common/inputs/SwitcherComponent';
import PopupComponent, { ErrorPopupComponent, ErrorPopupWithGridComponent, GenericSuccessPopupComponent, ErrorPopupWithTextAreaComponent, PhaseCondition, SuccessPopupComponent, ValidationSuccessPopupComponent, WarningPopupComponent, FullSyncWarningPopupComponent } from '../common/popups/PopupComponent';
import ProviderDetailsErrorModel from '../../models/ProviderDetails/ProviderDetailsErrorModel';
import ProviderDetailsExpansion, { SubjectMapping ,CourseMapping} from '../../models/ProviderDetails/ProviderDetailsExpansion';
import ProviderModel, { CSOD_PREDEFINED_SUBJECTS_MAPPING,CSOD_PREDEFINED_COURSE_MAPPING, ProviderModifications } from '../../models/ProviderDetails/ProviderModel';
import SSOConfiguration from './SSOConfiguration';
import SSOConfigErrorModel from '../../models/SSOConfig/SSOConfigErrorModel';
import ClientRegistration from './ClientRegistration';
import ClientRegistrationErrorModel from '../../models/ClientRegistration/ClientRegistrationErrorModel';
import CodeHelpers from '../../helpers/common/CodeHelpers';
import LabelComponent from '../common/inputs/LabelComponent';
import LargeTextboxComponent from '../common/inputs/LargeTextboxComponent';
import { InputWidthTypes } from '../../helpers/common/StyleHelper';
import FrameworkValidationService from '../../helpers/framework/FrameworkValidationService';
import GraphQLHelper from '../../helpers/common/GraphQLHelper';
import UpsertProviderModel from '../../models/ProviderDetails/UpsertProviderModel';
import LoaderComponent from '../common/LoaderComponent';
import "./FrameworkComponent.css";
import { FrameworkModes } from '../../models/ProviderFramework/FrameworkMode';
import GlobalLoaderStore from '../../stores/GlobalLoaderStore';
import ProviderToolData from '../../models/TestSubscription/ProviderToolData';
import HttpHelper from '../../helpers/common/HttpHelper';
import { ProviderOfferingType } from '../../models/ProviderDetails/ProviderOfferingType';
import DirectSubscriptionInput from '../../models/TestSubscription/DirectSubscriptionInput';
import { TestSubscriptionOption } from '../../models/TestSubscription/TestSubscriptionOption';
import SubscriptionInput from '../../models/TestSubscription/SubscriptionInput';
import ValidationApiErrorModel from '../../models/ProviderDetails/ValidationApiErrorModel';
import BundleProviderParameter from '../../models/TestSubscription/BundleProviderParameter';
import { v4 } from 'uuid';
import { CANCEL_BUTTON_CY_DATA, CANCEL_POPUP_CY_DATA, ERROR_POPUP_CY_DATA, PROVIDER_DETAILS_TAB_CY_DATA, SSO_CONFIGURATION_TAB_CY_DATA, SUBMIT_BUTTON_CY_DATA, SUCCESS_POPUP_CY_DATA, TEST_SUBSCRIPTIONS_TAB_CY_DATA } from '../../cypressDataConstants/providerFrameworkCyDataConstants';
import { PROVIDER_CUSTOM_TAXONOMY_POPUP_CY_DATA ,PROVIDER_CUSTOM_COURSE_MAPPING_POPUP_CY_DATA} from '../../cypressDataConstants/providerDetailsCyDataConstants';
import FrameworkConstants from '../../constants/frameworkConstants';
import { TrainingType } from '../../models/ProviderDetails/TrainingType';
import { Auth } from '@aws-amplify/auth';
import ProviderConstants from '../../constants/providersconstants';
import ProviderDetailConstants from '../../constants/providerDetailsConstants';
const { REACT_APP_ENV } = process.env;
console.log(process.env);
enum TabNames {
    ProviderDetails = "Provider Details",
    // TestSubscription = "Test Subscription",
    SSOConfiguration = "SSO Configuration",
    ClientRegistration = "Client Registration"

}

export enum PopupTypes {
    None,
    Success,
    Error,
    SavingError,
    Warning,
    FullSyncWarning,
    TaxonomyEdit,
    CourseMappingEdit,
    TestEndpointErrorWithGrid,
    TestEndpointErrorWithTextArea,
    TestEndpointSuccess,
    SyncSuccess,
    SyncFailure,
    MissingCIID,
    ClientRegisterSecret,
    ClientRegisterSuccess,
    ClientRegisterFail
}

interface FrameworkComponentProps {
    providers?: ProviderStore,
    globalLoader?: GlobalLoaderStore
}

interface FrameworkComponentState {
    CurrentTab: TabNames,
    CurrentPopup: PopupTypes,
    ProviderDetailsErrorMessages: ProviderDetailsErrorModel | null,
    SSOConfigErrorMessages: SSOConfigErrorModel | null,
    ClientRegistrationErrorMessage: ClientRegistrationErrorModel | null,
    TestSubscriptionErrorMessages: { [id: number]: string } | null,
    AdditionalSettingsErrorMessages: { [id: number]: string } | null,
    QuerystringParametersErrorMessages: { [id: number]: string } | null,
    IsRedirectingToProvidersGrid: boolean,
    ErrorPopupMessages: string[] | ValidationApiErrorModel[],
    ReadonlyState: boolean,
    AdminsState: boolean,
    IsSubmitRequestPosting: boolean,
    IsTestEnpointRequestPosting: boolean,
    S3Url: string,
    taxonomyErrorMessage: string,
    providerDetailsUpdaterCount:number,
    OldProvider: any,
    ShowForceSync: boolean,
    IsForceSyncRequestPosting: boolean,
    isScrolledToProblemElement: boolean,
    coursesCount?: number,
    testEndpointFullSync: boolean,
}

@inject("providers", "globalLoader")
@observer
export default class FrameworkComponent extends Component<FrameworkComponentProps, FrameworkComponentState> {
    private taxonomyValue: string = "";
    private courseMappingValue: string = "";
    private phaseConditions: PhaseCondition[] = [];

    constructor(props: FrameworkComponentProps) {
        super(props);
        this.state = {
            CurrentTab: TabNames.ProviderDetails,
            CurrentPopup: PopupTypes.None,
            IsRedirectingToProvidersGrid: false,
            ProviderDetailsErrorMessages: new ProviderDetailsErrorModel(),
            SSOConfigErrorMessages: new SSOConfigErrorModel(),
            TestSubscriptionErrorMessages: {},
            AdditionalSettingsErrorMessages: {},
            QuerystringParametersErrorMessages: {},
            ReadonlyState: false,
            AdminsState: false,
            S3Url: "",
            ErrorPopupMessages: [],
            IsSubmitRequestPosting: false,
            IsForceSyncRequestPosting: false,
            OldProvider: JSON.parse(JSON.stringify(this.props.providers?.CurrentProvider)),
            ShowForceSync: true,
            IsTestEnpointRequestPosting: false,
            taxonomyErrorMessage: "",
            providerDetailsUpdaterCount: 0,
            isScrolledToProblemElement: true,
            testEndpointFullSync: false
        }
        if (this.props.providers?.CurrentProviderDetailsExpansion.SubjectMappingType === SubjectMapping.Custom) {
            this.taxonomyValue = this.props.providers.CurrentProvider!.SubjectsMapping;
        }
        if (this.props.providers?.CurrentProviderDetailsExpansion.CourseMappingType === CourseMapping.Custom) {
            this.courseMappingValue = this.props.providers.CurrentProvider!.CourseMapping;
        }
        Auth.currentAuthenticatedUser().then(res=>{
            var groups = res.signInUserSession.accessToken.payload["cognito:groups"];
            if(groups && groups.includes('Readonly') && !groups.includes('Admins'))
              this.setState({ReadonlyState: true});
            if(groups.includes('Admins')){
              this.setState({AdminsState: true});
            }
        });
    }
    forceRefresh = () => {
        this.setState({providerDetailsUpdaterCount: this.state.providerDetailsUpdaterCount + 1});
    };
    getCcmsBundleId = (env: string | undefined) => {
        switch (env) {
            case "prod":
                return FrameworkConstants.CCMS_MEGA_BUNDLE_ID_prod;
            case "stge":
                return FrameworkConstants.CCMS_MEGA_BUNDLE_ID_stge;
        }
        return FrameworkConstants.CCMS_MEGA_BUNDLE_ID_dev;

    }

    onScrolledToProblemElement = () => {
        this.setState({ isScrolledToProblemElement: true });
    }

    getGoToTabFunction = (tab: TabNames) => {
        return (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.preventDefault();
            if (this.state.CurrentTab !== tab) {
                this.setState({ CurrentTab: tab });
            }
        }
    }

    SyncCCMSBundle = () => {
        // alert("This should call the updateCCMSBundleForProvider backend -- not yet implemented")
    }
    renderTab(tab: TabNames, cy_data?: string) {
        return <div className={`csod-tab-item non-selectable ${this.state.CurrentTab === tab ? "active-item gray-text" : "blue-text"}`} onClick={this.getGoToTabFunction(tab)} cy-data={cy_data}>{tab}</div>
    }

    setForceSync = () => {
        this.props.providers!.CurrentProvider!.ForceSync = true;
        this.closePopup();
    }
    revertForceSync = () => {
        this.props.providers!.CurrentProvider!.ForceSync = false;
        this.closePopup();
    }

    onIsForceSyncChanged = (fullSync: boolean) => {
        if (fullSync) {
            this.setState({ CurrentPopup: PopupTypes.FullSyncWarning })
        }
        else {
            this.props.providers!.CurrentProvider!.ForceSync = fullSync
        }
    }

    onTestFullSyncChanged = (value: boolean) => {
        this.setState({ testEndpointFullSync: value })
    }

    resetPSSOConfigErrorModel = () => {//for is sso enabled
        this.setState({ SSOConfigErrorMessages: new SSOConfigErrorModel() });
    }

    subscribeCall = (): Promise<any> => {
        var callsSequense: Promise<any>[] = [];
        if (this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.OneToOne || this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.Both) {
            [
                TestSubscriptionOption.TestPortal1,
                TestSubscriptionOption.TestPortal2
            ].forEach(tso => {
                if (this.props.providers?.CurrentTestSubscriptionConfig[tso].isChecked) {
                    callsSequense.push(GraphQLHelper.DirectSubscribeGQCall(new DirectSubscriptionInput(this.props.providers.CurrentProvider!.Id!, this.props.providers?.CurrentTestSubscriptionConfig[tso].url, this.props.providers?.CurrentTestSubscriptionConfig[tso].CIID)));
                }
            })
        }
        var oneToManySubscribed = false;
        if (this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.OneToMany || this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.Both) {
            [
                TestSubscriptionOption.CSODTestPortal,
                TestSubscriptionOption.SabaTestPortal
            ].forEach(tso => {
                if (this.props.providers?.CurrentTestSubscriptionConfig[tso].isChecked) {
                    oneToManySubscribed = true;
                    callsSequense.push(GraphQLHelper.SubscribeGQCall(new SubscriptionInput(this.props.providers?.CurrentTestSubscriptionConfig[tso].url, FrameworkConstants.SUBSCRIPTION_BUNDLE_ID)));
                }
            })
            if (oneToManySubscribed) {
                callsSequense.push(GraphQLHelper.AddProviderGQCall(new BundleProviderParameter(FrameworkConstants.SUBSCRIPTION_BUNDLE_ID, this.props.providers.CurrentProvider.Id!)));
            }
        }
        return Promise.all(callsSequense).then(responses => {
            this.phaseConditions.push({ phaseName: FrameworkConstants.SUBSCRIBE_PHASE_STRING, isPhasePassedSuccessfully: true });
        });
    }

    addProviderToMegabundleCall = () => {
        var ccmsBundleId = this.getCcmsBundleId(REACT_APP_ENV);
        if (this.props.providers?.CurrentProvider?.IsStrictSchema && this.props.providers.CurrentProviderDetailsExpansion.IsForCuration) {
            return GraphQLHelper.AddProviderGQCall(new BundleProviderParameter(ccmsBundleId, this.props.providers.CurrentProvider.Id!)).then(res => {
                this.phaseConditions.push({ phaseName: FrameworkConstants.ADD_TO_MEGABUNDLE_PHASE_STRING, isPhasePassedSuccessfully: true })
            })
        }
        return Promise.resolve();
    }

    upsertSettingsCall = () => {
        return GraphQLHelper.UpsertSettingsGQCall(ProviderToolData.ComposeProviderToolData(this.props.providers?.CurrentProvider!, this.props.providers?.CurrentProviderDetailsExpansion!, this.props.providers?.CurrentTestSubscriptionConfig!));
    }

    onForceSync = () => {
        this.setState({ IsForceSyncRequestPosting: true })
        var ciidString = this.props.providers?.CurrentProviderDetailsExpansion?.SelectedCIID.Ciid ?? this.props.providers?.CurrentProviderDetailsExpansion?.SelectedCIID;
        if (this.props.providers?.CurrentProvider?.ProviderOfferingType == ProviderOfferingType.OneToOne && (!ciidString || ciidString == "no ciid")) {
            this.setState({ CurrentPopup: PopupTypes.MissingCIID, IsForceSyncRequestPosting: false });
            return;
        }

        if (!ciidString)
            ciidString = "NonApplicableCiidString";
        ciidString = ciidString.replace(ProviderDetailConstants.CIID_CUSTOM_STRING,'');
        
        GraphQLHelper.ForceProviderSyncGQCall(this.props.providers?.CurrentProvider!, ciidString).then(s => {
            this.setState({ CurrentPopup: PopupTypes.SyncSuccess, IsForceSyncRequestPosting: false });
        })
            .catch((err) => {
                this.setState({
                    CurrentPopup: PopupTypes.SyncFailure,
                    ErrorPopupMessages: err && err.errors ? err.errors.map((i: any) => i.message) : [],
                    IsForceSyncRequestPosting: false
                });
            }).finally(() => {
                if (this.state.IsForceSyncRequestPosting) {
                    this.setState({ IsForceSyncRequestPosting: false })
                }
            })
    }

    finishSubmitProcess = (renderPopup: PopupTypes, errors?: any) => {
        this.setState({
            ErrorPopupMessages: errors && errors.errors ? errors.errors.map((i: any) => i.message) : [],
            CurrentPopup: renderPopup,
            IsSubmitRequestPosting: false
        })
    }
    deepCompare(obj1:any, obj2:any) {
        // Check if both arguments are objects
        if (typeof obj1 === 'object' && typeof obj2 === 'object' && obj1 !== null && obj2 !== null) {
            // Get the keys of both objects
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
    
            // Check if the number of keys is the same
            if (keys1.length !== keys2.length) {
                return false;
            }
    
            // Check if all keys in obj1 exist in obj2 and have the same value
            for (let key of keys1) {
                if (!obj2.hasOwnProperty(key) || !this.deepCompare(obj1[key], obj2[key])) {
                    return false;
                }
            }
    
            // If all checks passed, the objects are considered equal
            return true;
        } else {
            // Perform simple comparison for non-object types
            return obj1 === obj2;
        }
    }
    ensureDefaultCourseMapProperties = (currentMapping: string): string => {
        var defaultValues = {
            "URL":"url",
            "IsActive":"|SET_TRUE",
            "Title":"title",
            "Description":"text",
            "Thumbnail":"https://us-east-1-content-shared-components-public-prod-506226022422.s3.us-east-1.amazonaws.com/LtiManualDefaultCourseMappingProviderThumbnail/DefaultCourseMappingThumbnail.png|SET_STRING",
            "LastModifiedUTC":"|SET_CURRENT_DATE",
            "Languages":"en-US|SET_ARRAY",
            "Keywords":" |SET_STRING",
            "IsMobile": "|SET_TRUE",
            "MaxScore": "100|SET_INTEGER",
            "Custom":"custom",
            "Duration":"00:00:00|SET_STRING",
            "MasteryScore":"100|SET_INTEGER"
        };
        let mappingObj: Record<string, any> = {};
        if(currentMapping)
            mappingObj = JSON.parse(currentMapping);
            
        // Add any missing properties from defaultValues
        for (const [key, value] of Object.entries(defaultValues)) {
            if (!mappingObj[key]) {
                mappingObj[key] = value;
            }
        }
        return JSON.stringify(mappingObj);
    }

    findChangedProperties(obj1:any, obj2:any) {
        const changedProperties:any = {};
    
        // Iterate over all properties in obj1
        for (let key in obj1) {
            // Check if the property exists in obj2
            if (obj2.hasOwnProperty(key)) {
                // Check if the values are different
                if (!this.deepCompare(obj1[key], obj2[key])) {
                    // Add the property to the changedProperties dictionary
                    changedProperties[key] = {
                        oldValue: obj1[key],
                        newValue: obj2[key]
                    };
                }
            } else {
                // If the property doesn't exist in obj2, add it to changedProperties
                changedProperties[key] = {
                    oldValue: obj1[key],
                    newValue: undefined
                };
            }
        }
    
        // Iterate over all properties in obj2 to find any additional properties
        for (let key in obj2) {
            // Check if the property exists in obj1
            if (!obj1.hasOwnProperty(key)) {
                // Add the property to the changedProperties dictionary
                changedProperties[key] = {
                    oldValue: undefined,
                    newValue: obj2[key]
                };
            }
        }
    
        return changedProperties;
    }
    
    populateProviderChange = () => {
        if(this.state.OldProvider?.Name){
            return (this.findChangedProperties(this.state.OldProvider, this.props.providers?.CurrentProvider));
        }
    }

    onSubmitClick = () => {
        if(this.props.providers?.FrameworkMode === FrameworkModes.Create){
            this.props.providers.CurrentProvider!.CreatedDate = new Date().toUTCString();
        }
        
        this.setState({ IsSubmitRequestPosting: true });
        if(this.props.providers?.FrameworkMode === FrameworkModes.Create && this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.Push 
            && this.props.providers?.CurrentProvider?.Type === TrainingType.LTI){
                this.props.providers.CurrentProvider.CourseMapping = this.ensureDefaultCourseMapProperties(this.props.providers.CurrentProvider.CourseMapping);
                this.props.providers.CurrentProviderDetailsExpansion.CustomCourseMapping = this.props.providers.CurrentProvider.CourseMapping
                this.props.providers.CurrentProviderDetailsExpansion.CourseMappingType = CourseMapping.Custom
            }
        if(this.props.providers?.CurrentProvider?.Type === TrainingType.LTI && this.props.providers?.CurrentProvider.ProviderOfferingType !== ProviderOfferingType.Push){
            this.props.providers.CurrentProvider.LTIClientId = this.props.providers.CurrentProvider.Id;
        }
        
        var providerDetailsErrorMessages = FrameworkValidationService.ProviderDetailsValidate(this.props.providers?.CurrentProvider, this.props.providers?.CurrentProviderDetailsExpansion, this.props.providers?.CurrentBasicAuthConfig, this.props.providers?.CurrentOAuth2Config, this.props.providers?.CurrentApiKeyConfig!, this.props.providers?.Providers, this.props.providers?.FrameworkMode!);
        var ssoConfigurationErrorMessages = FrameworkValidationService.SSOConfigurationValidatate(this.props.providers?.CurrentSSOConfigModel);
        var testSubscriptionErrorMessages = FrameworkValidationService.TestSubscriptionValidate(this.props.providers?.CurrentTestSubscriptionConfig);
        if (providerDetailsErrorMessages != null || ssoConfigurationErrorMessages != null || testSubscriptionErrorMessages != null) {
            var tabToMove = providerDetailsErrorMessages != null ? TabNames.ProviderDetails : ssoConfigurationErrorMessages != null ? TabNames.SSOConfiguration : testSubscriptionErrorMessages != null ? TabNames.TestSubscription : this.state.CurrentTab;
            this.setState({
                isScrolledToProblemElement: false,
                ProviderDetailsErrorMessages: providerDetailsErrorMessages,
                SSOConfigErrorMessages: ssoConfigurationErrorMessages,
                TestSubscriptionErrorMessages: testSubscriptionErrorMessages,
                CurrentTab: tabToMove,
                IsSubmitRequestPosting: false
            })
        }
        else {
            var prvChanges = this.populateProviderChange();
            var modified = new ProviderModifications(Auth.Credentials.Auth.user.attributes.email,new Date().toLocaleString("en-US"));
            //Overloading lastModify to string containing the changes themselves.
            modified.LastModifiedBy = modified.LastModifiedBy + ' '  + JSON.stringify({'Changes':prvChanges });
     
            if(!this.props.providers!.CurrentProvider!.ProviderModifications)
                this.props.providers!.CurrentProvider!.ProviderModifications = [];

            if(this.props.providers!.CurrentProvider!.ProviderModifications != null && JSON.stringify(this.props.providers!.CurrentProvider!.ProviderModifications).length > 300000){
                this.props.providers.CurrentProvider.ProviderModifications.replace(this.props.providers.CurrentProvider?.ProviderModifications?.sort((a,b) => new Date(a.ProviderModified).getTime() - new Date(b.ProviderModified).getTime()));
                this.props.providers.CurrentProvider.ProviderModifications[0] = modified;
            }
            else
                this.props.providers!.CurrentProvider!.ProviderModifications.push(modified);
            GraphQLHelper.UpsertProviderGQCall(UpsertProviderModel.ComposeUpsertProviderModel(this.props.providers?.CurrentProvider!, this.props.providers?.CurrentOAuth2Config!, this.props.providers?.CurrentApiKeyConfig!, this.props.providers?.CurrentBasicAuthConfig!, this.props.providers?.CurrentProviderDetailsExpansion!, this.props.providers?.CurrentSSOConfigModel!))
                .then(() => {
                    this.phaseConditions.push({ phaseName: FrameworkConstants.UPSERT_PROVIDER_PHASE_STRING, isPhasePassedSuccessfully: true })
                    this.upsertSettingsCall().then(() => {
                        this.phaseConditions.push({ phaseName: FrameworkConstants.SETTINGS_PHASE_STRING, isPhasePassedSuccessfully: true })
                        // this.subscribeCall().then(() => {
                        this.addProviderToMegabundleCall().then(() => {
                            if(this.props.providers?.Providers.map(x=>x.Id).indexOf(this.props.providers?.CurrentProvider.Id) == -1) 
                                this.props.providers?.Providers.push(this.props.providers?.CurrentProvider);
                            this.finishSubmitProcess(PopupTypes.Success);
                        }).catch(err => {
                            this.phaseConditions.push({ phaseName: FrameworkConstants.ADD_TO_MEGABUNDLE_PHASE_STRING, isPhasePassedSuccessfully: false })
                            this.finishSubmitProcess(PopupTypes.Error, err);
                        })
                        // }).catch(err => {
                        //     this.phaseConditions.push({ phaseName: FrameworkConstants.SUBSCRIBE_PHASE_STRING, isPhasePassedSuccessfully: false })
                        //     this.finishSubmitProcess(PopupTypes.Error, err);
                        // });
                    }).catch(err => {
                        this.phaseConditions.push({ phaseName: FrameworkConstants.SETTINGS_PHASE_STRING, isPhasePassedSuccessfully: false })
                        this.finishSubmitProcess(PopupTypes.Error, err);
                    });
                }).catch(err => {
                    this.finishSubmitProcess(PopupTypes.SavingError, err);
                })
        }
    }

    closePopup = () => {
        this.setState({ CurrentPopup: PopupTypes.None })
        this.phaseConditions = [];
    }

    onS3OpenPopup = () => {
        if (this.state.S3Url)
            window.open(this.state.S3Url, 'popUpWindow');

        else if (this.state.ErrorPopupMessages[this.state.ErrorPopupMessages.length - 1]) {
            var s3Url = this.state.ErrorPopupMessages[this.state.ErrorPopupMessages.length - 1] as string;
            if (s3Url.includes('S3 Url:'))
                window.open(JSON.parse(s3Url).replace('S3 Url: ', ''), 'popUpWindow');
            else
                window.open(JSON.parse(this.state.ErrorPopupMessages[this.state.ErrorPopupMessages.length - 1].toString()).s3, 'popUpWindow');
        }
    }

    redirectToProvidersGrid = () => {
        this.props.providers!.CurrentProviderDetailsExpansion = new ProviderDetailsExpansion();
        this.props.providers!.CurrentProvider = new ProviderModel();
        this.setState({ IsRedirectingToProvidersGrid: true })
    }

    onCancelClick = () => {
        this.setState({ CurrentPopup: PopupTypes.Warning })
    }

    onSubmitTaxonomy = () => {
        try {
            if (CodeHelpers.IsJSONString(this.taxonomyValue)) {
                this.props.providers!.CurrentProviderDetailsExpansion.CustomTaxonomy = this.taxonomyValue;
                this.setState({ taxonomyErrorMessage: "", CurrentPopup: PopupTypes.None })
            } else {
                this.setState({ taxonomyErrorMessage: FrameworkConstants.TAXONOMY_ERROR_MESSAGE })
            }
        } catch {
            this.setState({ taxonomyErrorMessage: FrameworkConstants.TAXONOMY_ERROR_MESSAGE })
        }
    }

    onSubmitCourseMapping = () => {
        if(this.props.providers?.CurrentProvider?.Type === TrainingType.LTI && this.props.providers?.FrameworkMode === FrameworkModes.Edit && !this.state.AdminsState)   
        {
            this.setState({ courseMappingErrorMessage: FrameworkConstants.MAPPING_CANNOT_UPDATE })
            return;
        }

        try {
            if (CodeHelpers.IsJSONString(this.courseMappingValue)) {
                if(this.props.providers?.FrameworkMode === FrameworkModes.Edit && this.isJsonIDChanged(this.props.providers!.CurrentProviderDetailsExpansion.CustomCourseMapping, this.courseMappingValue)){
                    this.setState({ courseMappingErrorMessage: FrameworkConstants.ID_CANNOT_UPDATE })
                    return;
                }
                else{
                    this.props.providers!.CurrentProviderDetailsExpansion.CustomCourseMapping = this.courseMappingValue;
                    this.setState({ courseMappingErrorMessage: "", CurrentPopup: PopupTypes.None })
                }
                
            } else {
                this.setState({ courseMappingErrorMessage: FrameworkConstants.TAXONOMY_ERROR_MESSAGE })
            }
        } catch(err) {
            this.setState({ courseMappingErrorMessage: FrameworkConstants.TAXONOMY_ERROR_MESSAGE })
        }
    }


    onTaxonomyChanged = (value: string) => {
        this.taxonomyValue = value;
        this.props.providers!.CurrentProvider!.SubjectsMapping = value
    }
    onCourseMappingChanged = (value: string) => {
        if(this.props.providers?.CurrentProvider?.Type === TrainingType.LTI && this.props.providers?.FrameworkMode === FrameworkModes.Edit && !this.state.AdminsState)   
            return;

        this.courseMappingValue = value;
        this.props.providers!.CurrentProvider!.CourseMapping = value

    }

    
    onTestEndpoint = () => {
        this.setState({ IsTestEnpointRequestPosting: true });
        var subjectsMappingParsed = CodeHelpers.IsStringNullOrEmpty(this.props.providers?.CurrentProvider?.SubjectsMapping) ? {} : JSON.parse(this.props.providers!.CurrentProvider!.SubjectsMapping!);
        var clientIdAndSecretKey = UpsertProviderModel.setupClientIdAndSecretKey(this.props.providers?.CurrentBasicAuthConfig!, this.props.providers?.CurrentOAuth2Config!, this.props.providers?.CurrentApiKeyConfig!, this.props.providers?.CurrentProvider?.AuthenticationType)
        var ciidString = this.props.providers?.CurrentProviderDetailsExpansion?.SelectedCIID.Ciid ?? this.props.providers?.CurrentProviderDetailsExpansion?.SelectedCIID;
        var lastModifiedString = this.state.testEndpointFullSync ? null : this.props.providers?.CurrentProvider?.LastSuccessfulModifiedDateCourse;
        if (ciidString && this.props.providers?.CurrentProvider?.ProviderOfferingType == ProviderOfferingType.OneToOne)
            ciidString = "?ciid=" + ciidString;
        else {
            ciidString = "";
        }
        ciidString = ciidString.replace( ProviderDetailConstants.CIID_CUSTOM_STRING,'');
        HttpHelper.SendPostRequest(FrameworkConstants.VALIDATION_API_URL, {
            Abbreviation: this.props.providers?.CurrentProvider?.Abbreviation,
            Audience: this.props.providers?.CurrentProvider?.Audience,
            AuthenticationType: this.props.providers?.CurrentProvider?.AuthenticationType,
            ClientId: clientIdAndSecretKey.Username,
            ClientSecretKey: clientIdAndSecretKey.Password,
            AuthenticationUrl: clientIdAndSecretKey.AuthUrl,
            Scope: this.props.providers?.CurrentProvider?.Scope,
            CourseSyncUrl: this.props.providers?.CurrentProvider?.CourseSyncUrl + ciidString,
            Id: this.props.providers?.CurrentProvider?.Id,
            IsExcelProvider: this.props.providers?.CurrentProviderDetailsExpansion.IsExcelProvider,
            IsMobileSupported: this.props.providers?.CurrentProvider?.IsMobileSupported,
            IsActive: this.props.providers?.CurrentProvider?.IsActive ?? true,
            IsStrictSchema: this.props.providers?.CurrentProvider?.IsStrictSchema,
            LastSuccessfulModifiedDateCourse: lastModifiedString,
            Name: this.props.providers?.CurrentProvider?.Name,
            ProviderOfferingType: this.props.providers?.CurrentProvider?.ProviderOfferingType,
            SubjectsMapping: subjectsMappingParsed,
            SyncTime: this.props.providers?.CurrentProvider?.SyncTime,
            IsCCC: this.props.providers?.CurrentProvider?.IsCCC,
            Type: TrainingType[this.props.providers?.CurrentProvider?.Type!]
        }).then(res => {
            if (res.status == 304) {
                this.setState({ CurrentPopup: PopupTypes.TestEndpointSuccess, coursesCount: 0, IsTestEnpointRequestPosting: false });
                return;
            }
            var messages = res as { ID: string, error: string, childErrors: [] }[];
            var s3Url = res.S3Url;
            var coursesCount = res.IDs ;
            if (coursesCount > 0) {//message has success response structure
                this.setState({ S3Url: s3Url });
                this.setState({ CurrentPopup: PopupTypes.TestEndpointSuccess, coursesCount: coursesCount, IsTestEnpointRequestPosting: false });
            } else if (messages[0].error) {//message has simple error response structure
                this.setState({ CurrentPopup: PopupTypes.TestEndpointErrorWithTextArea, ErrorPopupMessages: messages.map(i => i.error ? i.error : ""), IsTestEnpointRequestPosting: false });
            } else {//message has array of errors response structure
                // if(res[0]["error:"])
                //     messages = [res[0]["error:"]];
                if (messages.map != null)
                    this.setState({ CurrentPopup: PopupTypes.TestEndpointErrorWithTextArea, ErrorPopupMessages: messages.map(i => (JSON.stringify(i))), IsTestEnpointRequestPosting: false });
                else
                    this.setState({ CurrentPopup: PopupTypes.TestEndpointErrorWithTextArea, ErrorPopupMessages: messages, IsTestEnpointRequestPosting: false });
            }
        })
            .catch((err) => {
                this.setState({ CurrentPopup: PopupTypes.TestEndpointErrorWithTextArea, ErrorPopupMessages: [err.message], IsTestEnpointRequestPosting: false });
            })
            .finally(() => {
                if (this.state.IsTestEnpointRequestPosting) {
                    this.setState({ IsTestEnpointRequestPosting: false })
                }
            });
    }

    renderPopup = () => {
        switch (this.state.CurrentPopup) {
            case PopupTypes.Success: return <SuccessPopupComponent FrameworkMode={this.props.providers?.FrameworkMode} ProviderName={this.props.providers?.CurrentProvider?.Name} OnClose={this.redirectToProvidersGrid} OnDone={this.redirectToProvidersGrid} cy_data={SUCCESS_POPUP_CY_DATA} />
            case PopupTypes.Error: return <ErrorPopupComponent ErrorMessages={this.state.ErrorPopupMessages as string[]} PhasesConditions={this.phaseConditions} OnClose={this.closePopup} TitleElements={["Provider ", <span key={v4()} className="blue-text">{this.props.providers?.CurrentProvider?.Name}</span>, " was saved, but the following errors occured"]} cy_data={ERROR_POPUP_CY_DATA} />
            case PopupTypes.SavingError: return <ErrorPopupComponent ErrorMessages={this.state.ErrorPopupMessages as string[]} OnClose={this.closePopup} TitleElements={["Failed to save provider ", <span className="blue-text">{this.props.providers?.CurrentProvider?.Name}</span>]} cy_data={ERROR_POPUP_CY_DATA} />
            case PopupTypes.Warning: return <WarningPopupComponent OnClose={this.closePopup} OnDone={this.redirectToProvidersGrid} cy_data={CANCEL_POPUP_CY_DATA} />
            case PopupTypes.FullSyncWarning: return <FullSyncWarningPopupComponent OnClose={this.revertForceSync} OnDone={this.setForceSync} />
            case PopupTypes.ClientRegisterSuccess:return <GenericSuccessPopupComponent OnClose={this.closePopup} Message={"OAuth Client Process Success"} OnDone={this.closePopup} showIcon={true} />
            case PopupTypes.ClientRegisterFail: return <ErrorPopupComponent  OnClose={this.closePopup} TitleElements={["OAuth Client Process Failed"]} ErrorMessages={[this.props.providers?.CurrentClientRegistrationDetails?.ErrorMessage]} />
            case PopupTypes.ClientRegisterSecret: return <PopupComponent OnClose={this.closePopup} Title="OAuth Client Process Success" AdditionalClass={"alternative-padding"} ErrorMessage={""} ButtonsProps={[
                { ButtonText: "Cancel", OnClick: this.closePopup, AdditionalClassForButton: "gray" },
            ]}> <LabelComponent title="Warning: This is the only time youâ€™ll see this secret. Copy it now and keep it safe." value={this.props.providers?.CurrentClientRegistrationDetails?.SecretString}
                isAbleToCopy={true} isHidden={false} widthClass={InputWidthTypes.Middle} /> 
            </PopupComponent>
            case PopupTypes.TaxonomyEdit: return <PopupComponent OnClose={this.closePopup} Title="Enter JSON subject taxonomy" AdditionalClass={"alternative-padding"} ErrorMessage={""} ButtonsProps={[
                { ButtonText: "Cancel", OnClick: this.closePopup, AdditionalClassForButton: "gray" },
                { ButtonText: "Submit", OnClick: this.onSubmitTaxonomy, AdditionalClassForButton: "blue" }
            ]}
                cy_data={PROVIDER_CUSTOM_TAXONOMY_POPUP_CY_DATA}>
                <LargeTextboxComponent title="" errorMessage={this.state.taxonomyErrorMessage} additionalClass="min-w-min-h-300-600" important={false} widthClass={InputWidthTypes.Maximum} defaultValue={this.props.providers?.CurrentProviderDetailsExpansion?.CustomTaxonomy} placeholder={CSOD_PREDEFINED_SUBJECTS_MAPPING} onValueChanged={this.onTaxonomyChanged} />
                <div className="csod-input-title-text gray-text padding-td-10">Paste the information in order to update custom taxonomy</div>
            </PopupComponent>
            case PopupTypes.CourseMappingEdit:
                return <PopupComponent OnClose={this.closePopup} Title="Enter JSON Course Mapping" AdditionalClass={"alternative-padding"} ErrorMessage={""} ButtonsProps={[
                { ButtonText: "Cancel", OnClick: this.closePopup, AdditionalClassForButton: "gray" },
                { ButtonText: "Submit", OnClick: this.onSubmitCourseMapping, AdditionalClassForButton: "blue" }
            ]}
                cy_data={PROVIDER_CUSTOM_COURSE_MAPPING_POPUP_CY_DATA}>
                <LargeTextboxComponent title="" errorMessage={this.state.courseMappingErrorMessage} additionalClass="min-w-min-h-300-600" important={false} widthClass={InputWidthTypes.Maximum} 
                defaultValue={this.props.providers?.CurrentProviderDetailsExpansion?.CustomCourseMapping !== "" ? JSON.stringify(JSON.parse(this.props.providers?.CurrentProviderDetailsExpansion?.CustomCourseMapping), null , 2) : ""}
                 placeholder={CSOD_PREDEFINED_COURSE_MAPPING} onValueChanged={this.onCourseMappingChanged} />
                <div className="csod-input-title-text gray-text padding-td-10">Paste the information in order to update course mapping</div>
            </PopupComponent>
            case PopupTypes.TestEndpointErrorWithGrid: return <ErrorPopupWithGridComponent ErrorDescriptionMessage={"Failed validation, due to the following reason"} ErrorMessages={this.state.ErrorPopupMessages as ValidationApiErrorModel[]} OnClose={this.closePopup} />
            case PopupTypes.TestEndpointErrorWithTextArea: return <ErrorPopupWithTextAreaComponent ErrorDescriptionMessage={"Failed validation, due to the following reason (Possibly no courses were returned)"} ErrorMessages={this.state.ErrorPopupMessages as string[]} OnClose={this.closePopup} OnS3Open={this.onS3OpenPopup} IsSync={false} />
            case PopupTypes.TestEndpointSuccess: return <ValidationSuccessPopupComponent CoursesCount={this.state.coursesCount!} OnClose={this.closePopup} OnDone={this.closePopup} OnS3Open={this.onS3OpenPopup} />
            case PopupTypes.SyncSuccess: return <GenericSuccessPopupComponent OnClose={this.closePopup} Message={"Provider has synced successfully"} OnDone={this.closePopup} showIcon={true} />
            case PopupTypes.MissingCIID: return <ErrorPopupComponent ErrorMessages={[("Please pick a CIID you want to sync from the drop down")]} OnClose={this.closePopup} />
            case PopupTypes.SyncFailure: return <ErrorPopupWithTextAreaComponent ErrorDescriptionMessage={"Failed syncing provider, due to the following reason"} ErrorMessages={this.state.ErrorPopupMessages as string[]} OnClose={this.closePopup} OnS3Open={this.closePopup} IsSync={true} />
            
            default: return null;
        }
    }

    renderReadonlyPosts= () => {
        if(!this.state.ReadonlyState)
        return <div className="csod-inputs-container">
                    <div className="csod-inputs-row-container">
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <button className="csod-button gray less-rounded-corners" onClick={this.onTestEndpoint}>{this.state.IsTestEnpointRequestPosting ? <LoaderComponent isLoading={true} /> : "Test Endpoint"}</button> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push?
                            <SwitcherComponent additionalClass="forceFullSyncCheckBox" title="Test Full Sync" defaultValue={this.state.testEndpointFullSync} onValueChanged={this.onTestFullSyncChanged} /> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <div className="csod-vertical-separator" /> : null}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <button className="csod-button gray less-rounded-corners" onClick={this.onForceSync}>{this.state.IsForceSyncRequestPosting ? <LoaderComponent isLoading={true} /> : "Sync Now"}</button> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push?
                            <SwitcherComponent additionalClass="forceFullSyncCheckBox" title="Full Sync" defaultValue={this.props.providers?.CurrentProvider?.ForceSync} onValueChanged={this.onIsForceSyncChanged} /> : <div />}
                    </div>
                    <div className="csod-inputs-row-container">
                        <button className="csod-button crimson less-rounded-corners" onClick={this.onCancelClick} cy-data={CANCEL_BUTTON_CY_DATA}>Cancel</button>
                        <button type="submit" className="csod-button blue less-rounded-corners" onClick={this.onSubmitClick} cy-data={SUBMIT_BUTTON_CY_DATA}>{this.state.IsSubmitRequestPosting ? <LoaderComponent isLoading={true} /> : "Submit"}</button>
                    </div>
               </div>
        else
        return <div className="csod-inputs-container">
                    <div className="csod-inputs-row-container">
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <button className="csod-button gray less-rounded-corners" onClick={this.onTestEndpoint}>{this.state.IsTestEnpointRequestPosting ? <LoaderComponent isLoading={true} /> : "Test Endpoint"}</button> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push?
                            <SwitcherComponent additionalClass="forceFullSyncCheckBox" title="Test Full Sync" defaultValue={this.state.testEndpointFullSync} onValueChanged={this.onTestFullSyncChanged} /> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <div className="csod-vertical-separator" /> : null}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push? <button className="csod-button gray less-rounded-corners" onClick={this.onForceSync}>{this.state.IsForceSyncRequestPosting ? <LoaderComponent isLoading={true} /> : "Sync Now"}</button> : <div />}
                        {this.state.CurrentTab === TabNames.ProviderDetails && this.state.ShowForceSync && this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push?
                            <SwitcherComponent additionalClass="forceFullSyncCheckBox" title="Full Sync" defaultValue={this.props.providers?.CurrentProvider?.ForceSync} onValueChanged={this.onIsForceSyncChanged} /> : <div />}
                    </div>
               </div>
    }

    isJsonIDChanged(oldJson: string, newJson: string): boolean {
        // Parse the JSON strings into objects
        const oldParsedJson = JSON.parse(oldJson);
        const newParsedJson = JSON.parse(newJson);

        // Extract the ID values
        const oldID = oldParsedJson.ID;
        const newID = newParsedJson.ID;

        // Compare the ID values
        if (oldID && newID !== oldID) {
            return true;
        }
        return false;
    }

    render() {
        const providers = this.props.providers;
        return this.props.globalLoader?.isLoading ? null :
            this.state.IsRedirectingToProvidersGrid || providers?.CurrentProvider == null ? <Redirect to={PROVIDERS_PAGE_PATH} /> : <div className="csod-framework-container">
                {this.renderPopup()}
                <div className="csod-breadcrumb-container">
                    <Link to={PROVIDERS_PAGE_PATH} className="csod-breadcrumb-item non-selectable blue-text">Content Providers</Link>
                    <div className="non-selectable">/</div>
                    <div className="csod-breadcrumb-item non-selectable gray-text">{this.props.providers?.FrameworkMode === FrameworkModes.Create ? "New Provider" : "Edit Provider"}</div>
                </div>
                <div className="csod-current-tab-title non-selectable">{`${this.props.providers?.FrameworkMode === FrameworkModes.Create ? "Create" : "Edit"} ${this.state.CurrentTab}`}</div>
                <div className="csod-tabs-container">
                    {this.renderTab(TabNames.ProviderDetails, PROVIDER_DETAILS_TAB_CY_DATA)}
                    {this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push &&  this.renderTab(TabNames.TestSubscription, TEST_SUBSCRIPTIONS_TAB_CY_DATA)}
                    {this.props.providers?.CurrentProvider?.ProviderOfferingType !== ProviderOfferingType.Push &&  this.renderTab(TabNames.SSOConfiguration, SSO_CONFIGURATION_TAB_CY_DATA)}
                    {this.props.providers?.CurrentProvider?.ProviderOfferingType === ProviderOfferingType.OneToOneCCC &&  this.renderTab(TabNames.ClientRegistration, undefined)}
                </div>
                <div className="csod-framework-content">
                    {this.state.CurrentTab === TabNames.ProviderDetails ? <ProviderDetails providerDetailsErrorMessages={this.state.ProviderDetailsErrorMessages!} onChildChange={this.forceRefresh} onScrolledToProblemElement={this.onScrolledToProblemElement} isScrolledToProblemElement={this.state.isScrolledToProblemElement} callTaxonomyPopup={() => { this.setState({ CurrentPopup: PopupTypes.TaxonomyEdit }) }} callCustomCourseMappingPopup={()=>{this.setState({ CurrentPopup: PopupTypes.CourseMappingEdit })}} /> : null}
                    {this.state.CurrentTab === TabNames.TestSubscription ? <TestSubscription testSubscriptionErrorMessages={this.state.TestSubscriptionErrorMessages!} onScrolledToProblemElement={this.onScrolledToProblemElement} isScrolledToProblemElement={this.state.isScrolledToProblemElement} /> : null}
                    {this.state.CurrentTab === TabNames.SSOConfiguration ? <SSOConfiguration ssoConfigErrorMessages={this.state.SSOConfigErrorMessages!} resetErrors={this.resetPSSOConfigErrorModel} onScrolledToProblemElement={this.onScrolledToProblemElement} isScrolledToProblemElement={this.state.isScrolledToProblemElement} /> : null}
                    {this.state.CurrentTab === TabNames.ClientRegistration ? <ClientRegistration onScrolledToProblemElement={this.onScrolledToProblemElement} isScrolledToProblemElement={this.state.isScrolledToProblemElement} 
                     callSecretPopup={() => { this.setState({ CurrentPopup: PopupTypes.ClientRegisterSecret }) }} 
                     callSuccessPopup={() => { this.setState({ CurrentPopup: PopupTypes.ClientRegisterSuccess }) }}  
                     callFailurePopup ={() => { this.setState({ CurrentPopup: PopupTypes.ClientRegisterFail }) }} /> : null}
                </div>
                <div className="csod-inputs-sticky-container">
                    {this.renderReadonlyPosts()}
                </div>
            </div>
    }
}
